import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Text from '@dbk/ui-text';
import { Checkbox } from '@dbk/ui-forms';
import Button from '@dbk/ui-buttons';

class ChatTermsAndConditions extends PureComponent {
  constructor(props) {
    super(props);
    const { terms } = this.props;
    this.state = {
      enableButtons: false,
      seenChatTerms: false,
      tcChatVersion: terms.tcChatVersion,
      termsChatUrl: terms.tcChatPdfLink,
      isTermsConditionsRead: false,
      seenTerms: '',
      seenPrivacy: '',
      privacyUrl: '',
      termsUrl: '',
      tcVersion: '',
      paVersion: '',
    };
    this.enableButtons = this.enableButtons.bind(this);
    this.acceptClicked = this.acceptClicked.bind(this);
    this.onTermsConditionClick = this.onTermsConditionClick.bind(this);
    this.props.loginTerms.onGetPdf();
  }
  enableButtons() {
    if (this.state.isTermsConditionsRead && document.getElementById('acceptTerms').checked) {
      this.setState({ enableButtons: true });
    } else {
      this.setState({ enableButtons: false });
    }
  }
  onTermsConditionClick() {
    if (!this.state.isTermsConditionsRead) {
      this.setState({ isTermsConditionsRead: true }, function () {
        if (this.state.isTermsConditionsRead && document.getElementById('acceptTerms').checked) {
          this.setState({ enableButtons: true });
        }
      });
    }
  }
  acceptClicked() {
    const seenChatTerms = true;
    const {
      seenTerms,
      seenPrivacy,
      privacyUrl,
      termsUrl,
      tcVersion,
      paVersion,
      termsChatUrl,
      tcChatVersion,
    } = this.state;
    this.props.chat.onSaveOnlineServiceTerms({
      seenTerms,
      seenPrivacy,
      termsUrl,
      privacyUrl,
      tcVersion,
      paVersion,
      termsChatUrl,
      seenChatTerms,
      tcChatVersion,
    });
    this.props.chat.setShowWelcomeScreen(false);
    this.props.chat.setShowChat(true);
  }
  render() {
    const { enableButtons } = this.state;
    const {
      i18n: { messages },
      terms: {tcChatPdfLink },
    } = this.props;
    const remoteUrl = window.location.href.split('ebanking')[0] + 'ebanking';
    const termsLink = remoteUrl + tcChatPdfLink;
    // const privacyLink = remoteUrl + pdfLinkData.paPdfLink;
    return (
      <div>
        <div className="pad-bottom-20">
          <a href={termsLink} className='term-condition-item' download="Online_terms.pdf" target="_blank" onClick={this.onTermsConditionClick}>
            {messages['app.chat.termsCondtnPrivacyPdf']}
          </a>
          <br />
        </div>
        <div className="text-indent">
          <Checkbox onChange={this.enableButtons} id="acceptTerms" />
          <Text secondary>
            {' '}
            {messages['app.chat.termsAndConditions.message']}
          </Text>
          {(this.props.chat.saveOnlineServiceTermsErrorMessage && this.props.chat.saveOnlineServiceTermsErrorMessage != '') &&
            <div className="center-content padding-top-30 large-4 medium-3 small-6">
              <Text style={{ color: 'red' }}>
                {this.props.chat.saveOnlineServiceTermsErrorMessage}
              </Text>
            </div>
          }
        </div>
        <div className="center-content padding-top-30">
            <Button onPress={this.acceptClicked} tertiary={!enableButtons}  disabled={!enableButtons}>
              {messages['app.chat.termsAndConditions.accept']}
            </Button>
        </div>
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    chat: {
      setShowWelcomeScreen: { $set: 'showWelcomeScreen' },
      setShowChat: { $set: 'showChat' },
      onSaveOnlineServiceTerms: { $call: 'saveOnlineServiceTerms' },
      saveOnlineServiceTermsErrorMessage: true
    },
    i18n: { messages: true },
    loginTerms: {
      onGetPdf: { $call: 'getPdfLink' }
    },
    terms: {
      tcPdfLink: true,
      paPdfLink: true,
      tcVersion: true,
      paVersion: true,
      showTermsConditions: true,
      showPrivacyAgreement: true,
      newUserTc: true,
      newUserPa: true,
      tcChatPdfLink: true,
      seenChatTerms: true,
      tcChatVersion: true,
    }
  }
})(ChatTermsAndConditions);
